import { OfferCodeSku, Sku } from '@v2/shared/lib/types';

/**
 * Overlays an offer code's prices onto the product's skus, joined on the sku's code.
 *
 * This is where headless did it and where it stays, rather than in the props builder.
 * Shared rather than owned by a page: the Magzter Gold pricing table and the book
 * product page both apply it, and one copy of it is the point.
 *
 * The `<` test is borrowed from the legacy MagzterGoldBanner's useMagzterGoldSku: an
 * offer whose price is not actually lower is not a sale, and writing it into
 * `sale_price` anyway would draw a struck-through price beside an identical one and a
 * "Save 0%" badge under it.
 *
 * `valid_until` rides along because the sku has no such field of its own — it belongs
 * to the offer, and PlanCard prints it as the date the sale ends.
 */
export default function applyOfferCodeSkus(skus: Sku[], offerCodeSkus: OfferCodeSku[]): Sku[] {
  if (!offerCodeSkus.length) {
    return skus;
  }

  const byCode = new Map(offerCodeSkus.map((offerCodeSku) => [offerCodeSku.sku_code, offerCodeSku]));

  return skus.map((sku) => {
    const offerCodeSku = byCode.get(sku.code);

    if (!offerCodeSku || !(offerCodeSku.price < sku.price)) {
      return sku;
    }

    return { ...sku, sale_price: offerCodeSku.price, valid_until: offerCodeSku.valid_until ?? null };
  });
}
